import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConnectKitProvider } from "connectkit";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { WagmiProvider } from "wagmi";
import App from "./App";
import { echoConfig, wagmiConfig } from "./config";
import "./index.css";
import { EchoProvider } from "./lib/useEcho";
import OAuthCallback from "./OAuthCallback";

const router = createBrowserRouter([
    { path: "/", element: <App /> },
    { path: "/oauth/callback", element: <OAuthCallback /> },
]);

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-800 text-white">
        <EchoProvider config={echoConfig}>
            <WagmiProvider config={wagmiConfig}>
                <QueryClientProvider client={queryClient}>
                    <ConnectKitProvider>
                        <RouterProvider router={router} />
                    </ConnectKitProvider>
                </QueryClientProvider>
            </WagmiProvider>
        </EchoProvider>
    </div>
);
